export function getTimeInputLabel(rp: Partial<RoutePoint>): string {
  switch (rp.stop_operation) {
    case "PICKUP":
      return "Ready Date";
    case "DROPOFF":
      return "Delivery Date";
    default:
      return "Date";
  }
}

export function areRouteTimesValid(
  startTime: string | undefined,
  index?: number,
): string | null {
  const indexText = index !== undefined ? `Route point ${index + 1}:` : "";
  if (startTime == null || startTime === "") {
    return `${indexText} ready date can not be empty.`;
  }

  return null;
}

/*
Strips email addresses out of an API error message so it can be sent to product
analytics. Two posting rejections quote the address the shipper typed for a
private shipment invite, which belongs to a third party rather than to the user
the event is attributed to. Redacting here rather than dropping the message
keeps every other rejection reason legible, and covers any message a future
handler adds without it having to know about analytics.
*/
export function redactEmails(text: string): string {
  return text.replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, "[email]");
}

/*
Numeric fields are held as strings in the form state so typing is not restricted.
The request body carries them as numbers; empty input becomes null. Number()
rejects partial parses like "12abc" or "1,500" outright (parseFloat would read
them as 12 and 1), so junk is never mis-read as a smaller number.
*/
export function parseNumericFormInput(value: string): number | null {
  const trimmed = value.trim();
  if (trimmed === "") {
    return null;
  }
  const parsed = Number(trimmed);

  return Number.isFinite(parsed) ? parsed : null;
}
